import type { MaintenanceDueStatus, WorkOrderPart } from '@rfleet/shared';

export interface VehicleLite { id: string; plateAr: string; name: string | null; status: string; odometerKm: number | null; engineHours: number | null }

export interface ScheduleRow {
  id: string;
  vehicleId: string;
  title: string;
  intervalType: 'KM' | 'DAYS' | 'ENGINE_HOURS';
  intervalValue: number;
  remindBefore: number;
  lastDoneAt: string | null;
  lastDoneOdometerKm: number | null;
  nextDueAt: string | null;
  nextDueOdometerKm: number | null;
  isActive: boolean;
  vehicle: VehicleLite;
  due: { status: MaintenanceDueStatus; remaining: number | null; unit: 'km' | 'h' | 'days'; nextDueAt: string | null; nextDueOdometerKm: number | null };
}

export interface WorkOrderRow {
  id: string;
  number: string;
  vehicleId: string;
  scheduleId: string | null;
  title: string;
  description: string | null;
  status: 'OPEN' | 'IN_PROGRESS' | 'DONE' | 'CANCELLED';
  workshopName: string | null;
  openedAt: string;
  startedAt: string | null;
  completedAt: string | null;
  odometerKm: number | null;
  laborCostEgp: number;
  partsCostEgp: number;
  totalCostEgp: number;
  parts: WorkOrderPart[] | null;
  invoiceFileId: string | null;
  setVehicleMaintenance: boolean;
  vehicle: VehicleLite;
  schedule: { id: string; title: string; intervalType: string } | null;
}

export interface WorkOrderDetail extends WorkOrderRow { invoiceUrl: string | null; actions: string[] }

export interface DocumentRow {
  id: string;
  vehicleId: string;
  type: string;
  title: string;
  number: string | null;
  issuedAt: string | null;
  expiresAt: string | null;
  fileId: string | null;
  remindDaysBefore: number;
  daysLeft: number | null;
  vehicle?: { id: string; plateAr: string; name: string | null };
}

export interface MaintenanceSummary {
  overdue: number;
  dueSoon: number;
  schedules: number;
  openWorkOrders: number;
  inProgressWorkOrders: number;
  doneWorkOrders: number;
  monthCostEgp: number;
  documentsExpiring: number;
  documentsExpired: number;
}

export const dueTone = (s: MaintenanceDueStatus): 'danger' | 'warning' | 'success' | 'neutral' => (s === 'OVERDUE' ? 'danger' : s === 'DUE_SOON' ? 'warning' : s === 'OK' ? 'success' : 'neutral');
export const woTone = (s: WorkOrderRow['status']): 'info' | 'warning' | 'success' | 'neutral' => (s === 'OPEN' ? 'info' : s === 'IN_PROGRESS' ? 'warning' : s === 'DONE' ? 'success' : 'neutral');
export const docTone = (daysLeft: number | null): 'danger' | 'warning' | 'success' | 'neutral' => (daysLeft == null ? 'neutral' : daysLeft < 0 ? 'danger' : daysLeft <= 30 ? 'warning' : 'success');
